import {Component} from '@angular/core';
import {Service} from '../../../models/service';
import {ServicesService} from '../../../services/services.service';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.scss']
})
export class NewServiceComponent {

  service: Service = new Service();
  options = [];

  constructor(private servicesService: ServicesService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  createService() {
    this.service.options = this.options.map(item => item.value);
    const requiredSuccess = this.utilsService.validateRequiredFields(this.service.type, this.service.options);
    if (requiredSuccess) {
      this.servicesService.createService(this.service).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Service Created !!', '');
          this.router.navigate(['/services']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create service.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }


}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/services/new-services/new-service.component.ts